import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import Grid from 'apollo-react/components/Grid';
import Select from '@mui/material/Select';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useReducer,useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, OBJ_ROLE,USERROLE_CODE, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import FormDialog from '../common/FormDialog';
import Loading from '../common/Loading';
import { getApi, getFuncroleFlg, postApi, setURL, redirectToLogin } from '../common/Utils';
import { Box } from '@mui/material';
import './ManageService.scss';
import usrUsrRoleListProj from '../json/usrUsrRoleListProj.json'; // フォルダ名選択時の既存ユーザー用
import usrUsrRoleList from '../json/usrUsrRoleList.json'; //ユーザー追加用
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import { useForm, useFieldArray } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import Trash from 'apollo-react-icons/Trash';
import selectItemAuditData from '../json/selectItemAuditData.json';

function ManageService() {
	const location = useLocation();
	const [t] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		SAVE_CONFIRM_DIALOG: '3',
		DELETE_FOLDER_CONFIRM_DIALOG: '4',
		COMPLETE_DIALOG: '5',
		OK_DIALOG_BACK: '6',
		DETAIL_DIALOG_BACK: '7',
		SAVE_SUCCESS_DIALOG: '8',
	};

	// 確認ダイアログ表示用フラグ												
	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');

	// 各種権限												
	const [searchUserBtn, setSearchUserBtn] = useState(false);
	const [permissionSelector, setPermissionSelector] = useState(false);
	const [userDelete, setUserDelete] = useState(false);
	const [userCancelBtn, setUserCancelBtn] = useState(false);

	// フォルダ管理画面orフォルダ作成画面からの値をもとに値をセットする												
	const { auditName, auditCode} = location.state || {};

	// 権限設定情報の入力内容（APIで使用する）												
	const [formValues, setFormValues] = useState({
		auditCode: auditCode,
		usrRole: '',
		auditName: auditName,
	});

	// 各種リスト												
	const [userList, setUserList] = useState([]);

	/**												
	 * 共通エラー処理												
	 * @param {object} error エラーオブジェクト												
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ												
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {

			const target = /該当データ/;
			if (error.message.match(target)) {
				const message = t('message.1005000');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
				return;
			}

			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	// 各種ボタンのハンドリング												

	/**												
	 * ダイアログでOKボタン押下時の処理												
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		if (dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) {
			navigate('/userManagement');
		}
	};

	/**												
	 * 確認ダイアログでキャンセルボタン押下時の処理												
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	// 保存ボタン押下処理
	const saveProcess = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);

		// 変更のある対象を取得
		const changedRows = [];

		// 権限の変更対象を取得
		userList.forEach(user => {
			let hasChange = false;

			// 権限変更チェック
			if (selectedRoles[user.usrCode].usrRole !== initialRoles[user.usrCode].usrRole) {
				changedRows.push({
					usrroleCode: selectedRoles[user.usrCode].usrRole,
					usrCode: user.usrCode,
					usrroleCodeBefore: initialRoles[user.usrCode].usrRole,
					changeType: "3",
				});
				hasChange = true;
			}

			// 削除チェック
			if (selectedDeletes[user.usrCode].isDelete == true) {
				changedRows.push({
					usrroleCode: selectedRoles[user.usrCode].usrRole,
					usrCode: user.usrCode,
					changeType: "2",
				});
				hasChange = true;
			}

			// 変更なしの場合
			if (!hasChange) {
				changedRows.push({
					usrroleCode: selectedRoles[user.usrCode].usrRole,
					usrCode: user.usrCode,
					changeType: "0",
				});
			}
		});

		// 追加ユーザーを取得 ※重複もチェック
		const userCodes = new Set();
		for (let adduser of fields) {
			if (adduser.usrCode !== '' && adduser.role !== '' && adduser.role !== undefined) {
				if (userCodes.has(adduser.usrCode)) {
					const message = t('errormsg.1001100'); // 重複ユーザーのエラーメッセージ
					setDialogStatus(DIALOG_STATUS.OK_DIALOG);
					setDialogOpen(true);
					setDialogContent(message);
					return;
				}
				userCodes.add(adduser.usrCode);
				changedRows.push({
					usrroleCode: adduser.role,
					usrCode: adduser.usrCode,
					changeType: "1",
				});
			} else {
				const message = t('errormsg.1001000'); // 入力エラーメッセージ
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
				return;
			}

			for (let user of userList) {
				if (adduser.usrCode === user.usrCode) {
					const message = t('errormsg.1001100'); // 重複ユーザーのエラーメッセージ
					setDialogStatus(DIALOG_STATUS.OK_DIALOG);
					setDialogOpen(true);
					setDialogContent(message);
					return;
				}
			}
		}

		// 変更なしチェックを削除（すべてのユーザーを含むため）
		// if (changedRows.length === 0) {
		// 	setDialogStatus(DIALOG_STATUS.OK_DIALOG);
		// 	const message = format(t('message.1003510'), "");
		// 	setDialogOpen(true);
		// 	setDialogContent(message);
		// 	return;
		// }

		// selectedRoles（変更後の各リスト）＋ 追加するユーザーのリスト上にサービス管理者がいないならば中止
		let serviceManagerCount = 0;

		// 変更前のサービス管理者カウント　※既存ユーザーの場合
		userList.forEach(user => {
			// 削除しないときのみカウント
			if (selectedDeletes[user.usrCode].isDelete == false) {
				if (selectedRoles[user.usrCode].usrRole == USERROLE_CODE.SERVICE_MANAGER_CODE) {
					serviceManagerCount++;
				}
			}
		});

		// 追加・変更後のユーザーのサービス管理者カウント
		changedRows.forEach(user => {
			// 既存ユーザーの変更かどうかの判定
			if (user.changeType == "1") { // 1:追加 2:削除 3:変更
				// 追加の場合でサービス管理者が選択されている場合
				if (user.usrroleCode == USERROLE_CODE.SERVICE_MANAGER_CODE) {
					serviceManagerCount++;
				}
			}
			if (user.changeType == "3") {
				if (selectedDeletes[user.usrCode].isDelete == false) { // 削除対象ではないときのみカウント
					if (user.usrroleCode == USERROLE_CODE.SERVICE_MANAGER_CODE) {
						serviceManagerCount++;
					}
				}
			}
			// 変更なしの場合もカウント
			if (user.changeType == "0") {
				if (user.usrroleCode == USERROLE_CODE.SERVICE_MANAGER_CODE) {
					serviceManagerCount++;
				}
			}
		});

		// サービス管理者のカウントが0だった場合は画面にメッセージを表示して処理を中断
		if (serviceManagerCount == 0) {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			const message = format(t('message.1003600'), "");
			setDialogOpen(true);
			setDialogContent(message);
			return;
		}

		const url = setURL(API_URL.AUDIT_AUTH);
		let formData = new FormData();
		formData.append('auditCode', formValues.auditCode);

		// Base64エンコーディングを使用して特殊記号をエスケープし、WAFルールに引っかからないようにする
		const encodedData = btoa(JSON.stringify(changedRows));
		formData.append('changeAuthList', encodedData);

		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.MANAGE_SERVICE,
			body: formData,
			success: saveSuccess,
			error: saveError,
		};
		postApi(postApiParam);
	}

	/**												
	 * キャンセルボタン押下時の処理												
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	// 保存及び更新処理完了時												
	function saveSuccess() {
		setDialogStatus(DIALOG_STATUS.SAVE_SUCCESS_DIALOG);
		const message = format(t('message.1003500'), "");
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**												
	 * 保存及び更新処理の失敗時の処理												
	 * @param {object} error エラーオブジェクト												
	 */
	function saveError(error) {
		const detailErrorMessage = '保存及び更新処理でエラーが発生しました。\n(An error occurred during the select item process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン											
		redirectToLogin();
	};

	/**												
	 * 共通フォルダ管理画面遷移処理												
	 */
	const commonBack = () => {
		// フォルダ管理画面へ遷移											
		navigate('/userManagement');
	};

	const onFinished = () => {

		const param = {
			auditName: formValues.auditName,
			auditCode: formValues.auditCode,
		};

		// URLにパラメータを追加											
		let newUrl = new URL(window.location.href);
		Object.keys(param).forEach(key => newUrl.searchParams.set(key, param[key]));

		// 新しいURLにリダイレクト											
		window.location.href = newUrl.toString();
	}

	/**												
	 * 権限設定ボタン押下時の処理												
	 */
	const handleSettingPermissionClick = () => {
		setDialogStatus(DIALOG_STATUS.SAVE_CONFIRM_DIALOG);
		const message = t('message.1003400');
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);
	}

	// 変更前の状態												
	const [initialRoles, setInitialSelectedRoles] = useState({});
	// 変更後の状態												
	const [selectedRoles, setSelectedRoles] = useState({});
	// 削除するユーザーを格納するリスト												
	const [selectedDeletes, setSelectedDeletes] = useState({});
	// ユーザー一覧												
	const [allUserRoleList, setAllUserRoleList] = useState({});

	// サービス一覧
	const [serviceList,setServiceList] = useState({});

	/**												
	 * 選択したサービスの初期表示ユーザー取得APIの成功時の処理												
	 * @param {array} response 												
	 */
	function usrUsrRoleListProjSuccess(response) {
		// 選択されたフォルダ名所属ユーザーリストをセット
		const userList = response.map(item => {
			if (item.usrCode !== null) {
				return {
					usrCode: item.usrCode,
					usrName: item.usrName,
					responseUserRoleList: item.responseUserRoleList
				};
			}
			return null;
		}).filter(item => item !== null);
		setUserList(userList);

		const initialRoles = {};
		const initialDeletes = {};
		response.forEach(user => {
			initialRoles[user.usrCode] = {
				usrCode: user.usrcode,
				usrRole: user.responseUserRoleList[0]?.usrroleCode || '',
			}
			initialDeletes[user.usrCode] = {
				usrCode: user.usrCode,
				isDelete: false,
			};
		});
		setSelectedRoles(initialRoles);
		setInitialSelectedRoles(initialRoles);
		setSelectedDeletes(initialDeletes);
	};

	// 権限変更処理												
	const handleRoleChange = (usrCode, value) => {
		setSelectedRoles(prevState => ({
			...prevState,
			[usrCode]: {
				...prevState[usrCode],
				usrCode: usrCode,
				usrRole: value,
			}
		}));
	};

	// 初期表示ユーザーの削除チェック状態を格納する												
	const handleDeleteChange = (usrCode, value) => {
		selectedDeletes[usrCode] = {
			usrCode: usrCode,
			isDelete: value,
		};
	};

	// 追加ユーザーの権限変更処理												
	const handleAddUserRoleChange = (index, value) => {
		fields[index].role = value;
		setValue(`tasks.${index}.role`, value);
	};

	/**												
	 * 選択したサービスの初期表示ユーザー取得APIの失敗時の処理												
	 * @param {object} error エラーオブジェクト												
	 */
	function usrUsrRoleListProjError(error) {
		const detailErrorMessage = 'フォルダ名取得処理でエラーが発生しました。\n(An error occurred during the getrolelist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン											
		redirectToLogin();
	};

	/**												
	 * 追加ユーザー取得APIの成功時の処理												
	 * @param {array} response 												
	 */
	function usrUsrRoleListSuccess(response) {
		// 選択されたフォルダ名所属ユーザーリストをセット
		const userList = response.map(item =>
		({
			usrCode: item.usrCode,
			usrName: item.usrName,
			responseUserRoleList: item.responseUserRoleList,
			role: ''
		})
		);
		setAllUserRoleList(userList);
	};

	/**												
	 * 自身の所属するもしくは管理者ならすべてのサービス取得APIの成功時の処理												
	 * @param {array} response 												
	 */
	function getAuditListSuccess(response) {
		// 選択されたフォルダ名所属ユーザーリストをセット
		const serviceList = response.map(item =>
		({
			auditCode: item.auditCode,
			auditName: item.auditName,
		})
		);
		setServiceList(serviceList);
	};


	/**												
	 * 選択したサービスの初期表示ユーザー取得APIの失敗時の処理												
	 * @param {object} error エラーオブジェクト												
	 */
	function usrUsrRoleListError(error) {
		const detailErrorMessage = 'ユーザー情報取得処理でエラーが発生しました。\n(An error occurred during the getrolelist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン											
		redirectToLogin();
	};

	// // C#のプレースホルダーをJavascriptで使用するための処理												
	const format = (str, ...args) => {
		for (const [i, arg] of args.entries()) {
			const regExp = new RegExp(`\\{${i}\\}`, 'g')
			str = str.replace(regExp, arg)
		}
		return str
	}

	// 入力でユーザー追加を行えるようにする処理-----------------------------------------------												

	// React Hook Form を使うための基本設定												
	const { register, handleSubmit, reset, control, setValue } = useForm({
	});

	// input を動的に増減させるための設定												
	const { fields, append, remove } = useFieldArray({
		control,
		name: "tasks"
	});

	// submitボタンを押した時に行う処理												
	const onSubmit = (data) => {
		const list = [];
		data.tasks.forEach((item, index) =>
			list.push(`\nタスク番号${index}:${item.taskValue}`)
		);
		// 送信後 input の入力欄を初期化											
		reset();
	};

	// input をいくつ追加したかカウント												
	const [count, setCount] = useState(0);
	const countUp = () => setCount(count + 1);

	// 削除対象のindexを保管												
	const [deleteIdx, setDeleteIdx] = useState(0);

	// input を減らすボタンを押した時の処理												
	const reduce = (index) => {
		setDeleteIdx(index);
		setDialogStatus(DIALOG_STATUS.DELETE_USER_CONFIRM_DIALOG);
		const message = t('message.1003300');
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);
	};

	/**												
	 * 取り消しボタン押下時の処理												
	 */
	const handleDeleteButton = () => {

		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);

		if (count > 0) {
			remove(deleteIdx);
			setCount(count - 1);
		}
	}

	// サービス名を選択した際の処理
	const handleAuditChange = (value) => {
		formValues.auditCode = value.target.value;
		formValues.auditName = value.target.key;

		if(formValues.auditCode != null)
		{
			const params = {};
			params['auditCode'] = formValues.auditCode;
			const urlSearchParam = String(new URLSearchParams(params));
			const projecturl = setURL(API_URL.AUDIT_AUTH_USER_ROLE_LIST_AUDIT) + '?';
			const getUserApiParam = {
				url: projecturl + urlSearchParam,
				sysRole: SYS_ROLE.MANAGE_SERVICE,
				success: usrUsrRoleListProjSuccess,
				error: usrUsrRoleListProjError,
				json: usrUsrRoleListProj,
			}
			getApi(getUserApiParam);
		}
		else
		{
			setUserList();
			setSelectedRoles();
			setInitialSelectedRoles();
			setSelectedDeletes();
		}
	}


	// 画面表示時の処理
	useEffect(() => {
		(async () => {
			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}

			// リダイレクトしてきた場合の値セット										
			let reparams = new URLSearchParams(window.location.search);

			// 各パラメータを取得										
			if (reparams.get('auditName')) {
				formValues.auditName = reparams.get('auditName');
			}
			if (reparams.get('auditCode')) {
				formValues.auditCode = reparams.get('auditCode');
			}

			// 権限系設定										
			const userDeleteAuth = getFuncroleFlg(SYS_ROLE.MANAGE_SERVICE, OBJ_ROLE.USER_DELETE);
			setUserDelete(userDeleteAuth);

			const userCancelBtnAuth = getFuncroleFlg(SYS_ROLE.MANAGE_SERVICE, OBJ_ROLE.USER_CANCEL_BTN);
			setUserCancelBtn(userCancelBtnAuth);

			const permissionSelectorAuth = getFuncroleFlg(SYS_ROLE.MANAGE_SERVICE, OBJ_ROLE.PERMISSION_SELECTOR);
			setPermissionSelector(permissionSelectorAuth);

			const searchUserBtnAuth = getFuncroleFlg(SYS_ROLE.MANAGE_SERVICE, OBJ_ROLE.SEARCH_USER_BTN);
			setSearchUserBtn(searchUserBtnAuth);

			// サービス一覧取得API
			const url = setURL(API_URL.AUDIT_AUTH_AUDIT);
			const getApiParam = {
				url: url,
				sysRole: SYS_ROLE.MANAGE_SERVICE,
				success: getAuditListSuccess,
				error: usrUsrRoleListError,
				json: selectItemAuditData,
			}
			await getApi(getApiParam);

			// // ユーザー追加用API										
			const url2 = setURL(API_URL.AUDIT_AUTH_USER_ROLE_LIST);
			const getApiParam2 = {
				url: url2,
				sysRole: SYS_ROLE.MANAGE_SERVICE,
				success: usrUsrRoleListSuccess,
				error: usrUsrRoleListError,
				json: usrUsrRoleList,
			}
			await getApi(getApiParam2);

			if(formValues.auditCode != null)
			{
				const params = {};
				params['auditCode'] = formValues.auditCode;
				const urlSearchParam = String(new URLSearchParams(params));
				const projecturl = setURL(API_URL.AUDIT_AUTH_USER_ROLE_LIST_AUDIT) + '?';
				const getUserApiParam = {
					url: projecturl + urlSearchParam,
					sysRole: SYS_ROLE.MANAGE_SERVICE,
					success: usrUsrRoleListProjSuccess,
					error: usrUsrRoleListProjError,
					json: usrUsrRoleListProj,
				}
				getApi(getUserApiParam);
			}
			else
			{
				formValues.auditCode = null;
				formValues.auditName = null;
				setUserList();
				setSelectedRoles();
				setInitialSelectedRoles();
				setSelectedDeletes();
			}

			setIsLoading(false);
		})();
	}, []);

	// ユーザー検索画面にてユーザーを選択して閉じたときの挙動												
	const onCloseUserSearch = (response) => {
		const row = allUserRoleList.find(user => user.usrCode === response.usrCode);
		if (!row) {
			usrUsrRoleListError('');
			return;
		}
		append({ usrCode: response.usrCode, usrName: response.usrName, responseUserRoleList: row.responseUserRoleList });
		countUp();
	}

	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		if(fields.length !== 0)
		{
			setIsVisible(true);
		}
		else
		{
			setIsVisible(false);
		}
	}, [fields]);

	
	useEffect(() => {
		if (Array.isArray(serviceList)) {
			const name = serviceList.find(item => item.auditCode === formValues.auditCode);
			if (name) {
				setFormValues(prevValues => ({ ...prevValues, auditName: name.auditName }));
			}
		}
	}, [formValues.auditCode, serviceList]);


	if (isLoading) {
		// ロード中の場合はローディング画面											
		return (
			<Loading />
		);
	} else {
		return (
			<Container className="manageService" maxWidth="lg">

				<Card className="card">
					<CardHeader
						title={t('manageService')}
						className="custom-card-header"
					/>
					<CardContent>
						<Grid container>

							<div className='description'>{t('manageServiceDescription')}</div>

							{/* サービス */}
							<Box display="flex" alignItems="center" width="100%">
								<Typography
									className="label"
								>
									{t('service')}
								</Typography>
								<Select
									className='serviceSelect'
									value={formValues.auditCode}
									onChange={handleAuditChange}
									displayEmpty
								>

									<MenuItem value={null}>
										<em className='placeholder'>{t('placeholder.1000300')}</em>
									</MenuItem>
									{serviceList.length > 0 && serviceList.map((item, index) => (
										<MenuItem key={index} value={item.auditCode}>
											{item.auditName}
										</MenuItem>
									))}

								</Select>
							</Box>
							{/* サービス　ここまで */}

							<Box display="flex" className="header" alignItems="center" width="100%">
								<Typography
									className="labelHeaderUser"
								>
									{t('userName')}
								</Typography>

								<Typography //権限を表示
									className="labelHeaderauthority"
								>
									{t('authority')}
								</Typography>

								<div className='labelHeaderSearchBtnSpace'></div>
								<Typography　// ダミープレースホルダー
									className="labelHeaderFolder"
								>
								</Typography>
								<Typography
									className="labelHeaderDelete"
								>
									{t('delete')}
								</Typography>
								<Typography
									className="labelHeaderRedo"
								>
									{isVisible && t('redo')}
								</Typography>
							</Box>
							{userList != null && userList.length != 0 && userList.map((user, index) => (
								<React.Fragment key={user.usrName}>
									<Box display="flex" key={index} value={user.usrName} alignItems="center" width="100%">
										<TextField
											className="textFieldUser"
											value={user.usrName}
											disabled
										/>
										<span className='dummySpacer' />
										<Select
											className="permissionUser"
											value={selectedRoles[user.usrCode].usrRole}
											onChange={(e) => handleRoleChange(user.usrCode, e.target.value)}
											disabled={!permissionSelector}
										>
											{user.responseUserRoleList.map((roleList, index) => (
												<MenuItem key={index} value={roleList.usrroleCode}>
													{roleList.usrroleDesc}
												</MenuItem>
											))}
										</Select>
										<Checkbox
											className='deleteCheckBox'
											value={selectedDeletes[user.usrCode].isDelete}
											onChange={(e) => handleDeleteChange(user.usrCode, e.target.checked)}
											disabled={!userDelete}
										/>
									</Box>
								</React.Fragment>
							))}

							{fields.map((field, index) => (
								<Box display="flex" key={field.id} alignItems="center" width="100%">
									<TextField
										className="textFieldUser"
										value={fields[index].usrName}
										disabled
									/>
									<span className='dummySpacer' />
									<Select
										className="permissionUser"
										value={fields[index].role}
										onChange={(e) => handleAddUserRoleChange(index, e.target.value)}
										disabled={!permissionSelector}
									>
										{field.responseUserRoleList.map((userRoleList, index) => (
											<MenuItem key={index} value={userRoleList.usrroleCode}>
												{userRoleList.usrroleDesc}
											</MenuItem>
										))}
									</Select>
									<div className='deleteCheckBox' />
									<IconButton
										className='trashBtn'
										onClick={() => reduce(index)}
										disabled={!userCancelBtn}
									>
										<Trash />
									</IconButton>
								</Box>
							))}
							<FormDialog 
								orgLevel0Code={formValues.orgLevel0Code} 
								disabled={!searchUserBtn || formValues.auditCode == null} 
								className="userSearchBtn" 
								onClose={onCloseUserSearch}  
								userListType="1"  /* 取得ユーザリスト区分（0:全ユーザ、1:IQVIA社員のみ） */
							/>
						</Grid>

						<Grid container justifyContent="flex-end" className='button'>
							<Button
								className="permissionSettingBtn"
								variant="primary"
								onClick={handleSettingPermissionClick}
								disabled={formValues.auditCode == null}
							>
								{t('save')}
							</Button>
							<Button
								className="cancelBtn"
								variant="secondary"
								onClick={handleCancelClick}
							>
								{t('cancel')}
							</Button>
						</Grid>
					</CardContent>
				</Card>

				{(dialogStatus === DIALOG_STATUS.OK_DIALOG || dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK) && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.DETAIL_DIALOG || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.SAVE_CONFIRM_DIALOG) && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={saveProcess}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.DELETE_USER_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={handleDeleteButton}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.SAVE_SUCCESS_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onFinished}
					/>
				)}

			</Container>
		);
	}
}
export default ManageService;													
